export default __webpack_public_path__ + "static/melon-loader-c2bc1dc706290730c3856a23e080a49a.png";